import { Box, Heading, Spinner, VStack } from "@chakra-ui/react";

type LoaderProps = {
  contained?: boolean;
};

const Loader = (props?: LoaderProps) => {
  if (!props?.contained) {
    return (
      <Box
        role="status"
        aria-live="polite"
        aria-label="Loading"
        position="fixed"
        top={0}
        left={0}
        width="100%"
        height="100vh"
        zIndex="9999999999999999"
        textAlign={"center"}
      >
        <Heading
          mt={32}
          fontSize="6xl"
          mb={8}
          color="teal.500"
          _dark={{ color: "white" }}
        >
          Loading
        </Heading>
        <Spinner
          size="xl"
          color="teal.500"
          _dark={{ color: "white" }}
          thickness="4px"
        />
      </Box>
    );
  }
  return (
    <VStack
      role="status"
      aria-live="polite"
      aria-label="Loading"
      width="100%"
      height="300px"
      textAlign={"center"}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <Heading
        fontSize="2xl"
        mb={8}
        color="teal.500"
        _dark={{ color: "white" }}
      >
        Loading
      </Heading>
      <Spinner
        size="xl"
        color="teal.500"
        thickness="4px"
        _dark={{ color: "white" }}
      />
    </VStack>
  );
};

export default Loader;
